<template>
  <!-- page-title -->
  <PageTitleComponent :key="$route.fullPath" />
  <!-- /page-title -->

  <!-- wg-about-us -->
  <AboutUsComponent :key="$route.fullPath" />
  <!-- /wg-about-us -->

  <!-- wg-open-hours -->
  <OpenHoursComponent :key="$route.fullPath" />
  <!-- /wg-open-hours -->

  <!-- wg-box-icon -->
  <DeliveryIconComponent :key="$route.fullPath" />
  <!-- <FullVideoComponent/> -->
  <!-- /wg-box-icon -->

  <!-- wg-testimonial -->
  <TestimonialComponent :key="$route.fullPath" />
  <!-- /wg-testimonial -->

  <!-- wg-our-menu -->
  <MenuComponent :key="$route.fullPath" />
  <!-- /wg-our-menu -->

  <!-- wg-franchise -->
  <FranchiseComponent :key="$route.fullPath" />
  <!-- /wg-franchise -->

  <!-- wg-location -->
  <LocationComponent :key="$route.fullPath" />
  <!-- /wg-location -->

</template>

<script>
import PageTitleComponent from "@/components/home/PageTitleComponent.vue";
import AboutUsComponent from "@/components/home/AboutUsComponent.vue";
import OpenHoursComponent from "@/components/home/OpenHoursComponent.vue";
import DeliveryIconComponent from "@/components/home/DeliveryIconComponent.vue";
import TestimonialComponent from "@/components/home/TestimonialComponent.vue";
import MenuComponent from "@/components/home/MenuComponent.vue";
import FranchiseComponent from "@/components/home/FranchiseComponent.vue";
import LocationComponent from "@/components/home/LocationComponent.vue";

export default {
  name: "HomeComponent",
  components: {
    PageTitleComponent,
    AboutUsComponent,
    OpenHoursComponent,
    DeliveryIconComponent,
    TestimonialComponent,
    MenuComponent,
    FranchiseComponent,
    LocationComponent,
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
